import React from "react";
import { markdown } from "markdown";

export default ({ textContent: { textContent } }) => (
  <section className="colorlib-about" data-section="other">
    <div>
      <div>
        <div>
          <div className="row">
            <div className="col-md-12">
              <div
                className="hire"
                dangerouslySetInnerHTML={{
                  __html: markdown.toHTML(textContent)
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/banner.js